/* eslint-disable camelcase */
import strongly_disagree_smiley from 'images/strongly-disagree-smiley.svg';
import disagree_smiley from 'images/disagree-smiley.svg';
import somewhat_disagree_smiley from 'images/somewhat-disagree-smiley.svg';
import somewhat_agree_smiley from 'images/somewhat-agree-smiley.svg';
import agree_smiley from 'images/agree-smiley.svg';
import strongly_agree_smiley from 'images/strongly-agree-smiley.svg';

export const ENGAGEMENT_ANSWERS = [
    'engagement.strongly_disagree', 'engagement.disagree', 'engagement.somewhat_disagree',
    'engagement.somewhat_agree', 'engagement.agree', 'engagement.strongly_agree'
];

export const EXTRA_QUESTIONS_ANSWERS = [
    'engagement.never', 'engagement.almost_never', 'engagement.rarely',
    'engagement.sometimes', 'engagement.often', 'engagement.very_often', 'engagement.always'
];

export const SMILEY_ICONS = [
    strongly_disagree_smiley,
    disagree_smiley,
    somewhat_disagree_smiley,
    somewhat_agree_smiley,
    agree_smiley,
    strongly_agree_smiley
];
